import { useNavigate } from "react-router-dom";

const CTA = () => {
  const navigate = useNavigate();

  return (
    <section id="contact" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-teal-700">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 40px, transparent 40px, transparent 80px)",
          }}
        ></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Siap Untuk Memulai?
        </h2>
        <p className="text-xl text-white/90 mb-12">
          Bergabunglah dengan ribuan komunitas perumahan yang telah merasakan
          kemudahan bWarga
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate("/register")}
            className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl"
          >
            Daftar Sekarang
          </button>
          <a
            href="https://wa.me/6281584114040"
            target="_blank"
            rel="noreferrer"
            className="bg-teal-800 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-900 transition-all border-2 border-white/30"
          >
            Hubungi Kami
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;

// import React from "react";
// import imageBackground from "../components/assets/BG.svg";

// const CTA = () => {
//   return (
//     <section
//       id="contact"
//       className="relative py-16 sm:py-24 overflow-hidden bg-teal-600"
//     >
//       {/* <div className="absolute inset-0 "> */}
//       <div
//         className="absolute inset-0 bg-center "
//         style={{
//           // backgroundImage:
//           //   "repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 40px, transparent 40px, transparent 80px)",

//           backgroundImage: `url(${imageBackground})`,
//           // backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       ></div>
//       {/* </div> */}
//       <div className="relative z-10 max-w-4xl mx-auto px-6 sm:px-6 lg:px-8 text-center">
//         <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
//           Siap Untuk Memulai?
//         </h2>
//         <p className="text-xl text-white/90 mb-12">
//           Bergabunglah dengan ribuan komunitas perumahan yang telah merasakan
//           kemudahan BWarga
//         </p>
//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           <button className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl">
//             Daftar Sekarang
//           </button>
//           <button className="bg-teal-800 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-900 transition-all border-2 border-white/30">
//             Hubungi Kami
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CTA;
